import styled from "styled-components"

export default function OrderInfoTableRow({ name, value }) {
  return (
    <TableRow>
      <Name>{name}</Name>
      <Value>{value}</Value>
    </TableRow>
  )
}

const TableRow = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: calc(100vw * (16 / 375));
`;

const Name = styled.span`
  flex-basis: calc(100vw * (52 / 375));
  margin-right: calc(100vw * (17 / 375));
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (20 / 375));
  color: #4E4E4E;
`;

const Value = styled.span`
  white-space: pre-wrap;
  font-size: calc(100vw * (14 / 375));
  font-weight: 400;
  line-height: calc(100vw * (20 / 375));
  color: #121212;
`;